module.exports = __webpack_public_path__ + "static/media/right_frog_lat.a28e6a01.jpg";